module.exports = __webpack_public_path__ + "static/media/platform-features-background.a0b61f83.png";